import { CheckIcon, CopyIcon } from '@chakra-ui/icons';
import {
  type As,
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  Text,
} from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { PopoverTrigger } from '@revelio/core';

export const SUMMARY_HEADING_PROPS = {
  mt: '5',
  pl: '5',
  as: 'h3' as As,
  fontWeight: '400',
  fontSize: 'sm',
  color: 'text.primary',
};

export const formatCountLabel = (
  count: number,
  singular: string,
  plural: string
) => {
  if (count === 0) {
    return `No ${plural}`;
  }
  if (count === 1) {
    return `1 ${singular}`;
  }
  return `${count} ${plural}`;
};

export const CopyButton = ({ value }: { value: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 5000);
  };

  return (
    <CopyToClipboard text={value} onCopy={handleCopy}>
      <IconButton
        icon={copied ? <CheckIcon color="green.500" /> : <CopyIcon />}
        aria-label="copy value"
        variant="unstyled"
        size="sm"
        color={copied ? 'green.500' : 'navyBlue.500'}
        className="copy-button"
        visibility="hidden"
      />
    </CopyToClipboard>
  );
};

export const SummaryTrigger = ({ text }: { text: string }) => (
  <Text
    as="u"
    textDecoration="none"
    borderBottom="1px dotted #000"
    mr="2px"
    cursor="help"
  >
    {text}
  </Text>
);

export const SummaryPopover = ({
  trigger,
  children,
}: {
  trigger: ReactNode;
  children: ReactNode;
}) => (
  <Popover trigger="hover" placement="right">
    <PopoverTrigger>
      <Box as="span">{trigger}</Box>
    </PopoverTrigger>
    <PopoverContent w="max-content">
      <PopoverArrow />
      <PopoverBody>{children}</PopoverBody>
    </PopoverContent>
  </Popover>
);
